class BlogHolder extends HTMLElement {
    constructor() {
        super()
        this.querySelectorAll("button.ml_blog_view_all").forEach(blogViewAll => {
            blogViewAll.addEventListener("click", (e) => {
                this.showAll();
            }, { pasive: true })
        })
    }

    showAll() {
        this.querySelectorAll(".ml_blog_view_all").forEach(blogViewAllBtn => {
            blogViewAllBtn.style.display = "none";
        })
        this.querySelectorAll(".ml_hide_blog").forEach(blogView => {
            blogView.classList.remove("ml_hide_blog")
        })
    }
}
customElements.define('ml-blog-holder', BlogHolder);

